import createFocusTrap from 'focus-trap';

const focusableQuery = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary, details, [tabindex]:not([tabindex="-1"])';

export default {
    directives: {
        'trap-focus': {
            mounted (element, binding) {

                // Before we set up the focus trap, we need to make sure our
                // element actually contains something focusable.
                let focusable = [...element.querySelectorAll(focusableQuery)]
                .filter(el => {
                    // check if the element, or any of its parents are not
                    // displayed in the DOM (e.g. when using display: none).
                    return !! el.offsetParent;
                }).length;

                if (!focusable) {
                    return;
                }

                element._focusTrap = createFocusTrap(element, {
                    escapeDeactivates: true,
                    clickOutsideDeactivates: true,
                    returnFocusOnDeactivate: false,
                });

                if (binding.value) {
                    element._focusTrap.activate();
                }
            },
            updated (element, binding) {

                if (!element._focusTrap) {
                    return;
                }

                element._focusTrap[binding.value ? 'activate' : 'deactivate']();
            }
        }
    }
}
